__turbopack_context__.v({
  "feedbackAction": "Portrait-module__EExSqa__feedbackAction",
  "feedbackBox": "Portrait-module__EExSqa__feedbackBox",
  "portraitHeader": "Portrait-module__EExSqa__portraitHeader",
});
